module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedThin.e410007.woff2";